import { render, staticRenderFns } from "./SearchResultFarvoriteModal.vue?vue&type=template&id=19f91023"
import script from "./SearchResultFarvoriteModal.vue?vue&type=script&lang=js"
export * from "./SearchResultFarvoriteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports